export default __webpack_public_path__ + "static/unilever-background-2d2c7cff0844d0704de7c417043d39ff.jpg";